import { createContext, useContext } from 'react';
import { trackEvent, TrackSegmentFunction } from '../trackEvent';

// Default value is undecorated segment tracking function
const SegmentTrackingContext = createContext<TrackSegmentFunction>(trackEvent);

export const SegmentTrackingProvider = SegmentTrackingContext.Provider;

export const useTrackSegmentEvent = () => {
    const trackSegmentEvent = useContext(SegmentTrackingContext);

    return trackSegmentEvent;
};
